import Image from 'next/image';

export default function AdvertisementPlaceholder() {
  return (
    <aside
      aria-label="Advertisement"
      className="overflow-hidden rounded-xl border border-blue-100 bg-white shadow-sm"
    >
      <div className="border-b border-gray-100 bg-gray-50/80 px-4 py-2 text-center text-[10px] font-semibold uppercase tracking-[0.18em] text-gray-400">
        Advertisement
      </div>
      <Image
        src="/invitd-ad-example.png"
        alt="Advertisement placeholder for free Invitd plans"
        width={1374}
        height={1145}
        sizes="(max-width: 672px) calc(100vw - 32px), 640px"
        className="block h-auto w-full"
      />
    </aside>
  );
}
